<template>
  <vs-row>
    <vs-col class="px-0" vs-type="flex" vs-xs="12" vs-w="4">
      <div class="profile-detail--card">
        <div class="profile-detail--card__profile">
          <div class="profile-detail--card__status">
            <feather-icon
              v-if="!successFullLetter()"
              svgClasses="h-10 w-10 text-danger"
              icon="XCircleIcon"
            />
            <feather-icon
              v-else
              svgClasses="h-10 w-10 text-success"
              icon="CheckCircleIcon"
            />
          </div>
          <div class="profile-detail-card__content">
            <h1 class="profile-detail--card__title">Carta de Apresentação</h1>
            <vs-button
              color="primary"
              type="flat"
              @click="$router.push({ name: 'presentation-letter' })"
            >
              {{
                talent.description === ""
                  ? "Adicione a sua carta de apresentação"
                  : "Atualize a sua carta de apresentação "
              }}
            </vs-button>
          </div>
        </div>
      </div>
    </vs-col>

    <vs-col
      class="profile-detail--card__space"
      vs-type="flex"
      vs-xs="12"
      vs-w="4"
    >
      <div
        v-if="Object.keys(recrutest).length <= 0"
        class="profile-detail--card"
      >
        <div class="profile-detail--card__profile">
          <feather-icon svgClasses="h-10 w-10 text-danger" icon="XCircleIcon" />
          <div class="profile-detail-card__content">
            <h3 class="profile-detail--card__title">
              Avaliação comportamental não realizada
            </h3>
            <vs-button color="primary" type="flat" @click="onRecrutestClick()">
              Iniciar Avaliação comportamental
            </vs-button>
          </div>
        </div>
      </div>

      <div v-else class="profile-detail--card">
        <div class="profile-detail--card__profile">
          <div class="profile-detail--card__status">
            <img :src="recrutest.icon" alt="recrutest icone" />
          </div>
          <div class="profile-detail-card__content">
            <h1 class="profile-detail--card__title">
              Perfil: {{ recrutest.title }}
            </h1>
            <vs-button
              color="primary"
              type="flat"
              @click="onRecrutestClick(recrutest['profile-link'])"
            >
              Ver perfil comportamental
            </vs-button>
          </div>
        </div>
      </div>
    </vs-col>

    <vs-col class="px-0" vs-type="flex" vs-xs="12" vs-w="4">
      <div class="profile-detail--card">
        <div class="profile-detail--card__profile">
          <feather-icon
            v-if="!successullProfessionalProfile()"
            svgClasses="h-10 w-10 text-danger"
            icon="XCircleIcon"
          />
          <feather-icon
            v-else
            svgClasses="h-10 w-10 text-success"
            icon="CheckCircleIcon"
          />
          <div class="profile-detail-card__content no-margin">
            <h1 class="profile-detail--card__title">
              Detalhes Profissionais Desatualizados!
            </h1>
            <vs-button
              color="primary"
              type="flat"
              @click="() => $router.push({ name: 'edit-professional-details' })"
            >
              Atualizar detalhes profissionais
            </vs-button>
          </div>
        </div>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import vSelect from "vue-select";
import { mapState, mapActions, mapGetters } from "vuex";
import { VMoney } from "v-money";
import axios from "axios";
export default {
  name: "profile-detail-card",
  created() {
    this.doRecrutest();
  },
  data() {
    return {
      successUpdate: false,
      successUpdateTitle: "Perfil Profissional atualizado!",
      popupActive: false,
      counterDanger: false,
      recrutest: {},
    };
  },
  computed: {
    ...mapState("basicInfo", ["basicInfo"]),
    ...mapState("address", ["address"]),
    ...mapState("talent", ["talent"]),
    ...mapGetters("professional_profile", ["emptyProfessionalProfile"]),
  },
  methods: {
    ...mapActions("professional_profile", ["addProfessionalProfile"]),

    successullProfessionalProfile() {
      return this.$store.getters["professional_profile/isFilled"];
    },

    successFullLetter() {
      return this.talent.description && this.talent.description.length > 0;
    },

    doRecrutest() {
      axios
        .get(
          `https://recrutest.recrutei.com.br/public/get-profile/1ae32id23if349vmv39f9hewvn8/${this.basicInfo.email}`,
          { headers: { "Access-Control-Allow-Origin": "*" } }
        )
        .then(async ({ data }) => {
          this.recrutest = await Object.assign({}, this.recrutest, { ...data });
        })
        .catch(console.error);
    },

    onRecrutestClick(link) {
      if (link !== undefined) return window.open(link, "_blank");

      const ssn = this.basicInfo.ssn.replace(/\./g, "").replace(/\-/g, "");

      const url = `https://recrutest.recrutei.com.br/register/web/new?name=${this.basicInfo.name}&email=${this.basicInfo.email}&ssn=${ssn}&city=${this.address.city}`;
      window.open(url, "_blank");
    },
  },
  components: {
    "v-select": vSelect,
    directives: { money: VMoney },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/components/profiledetailcard.scss";
</style>
